import { Button } from 'components/ui';
import { LanguageIcon } from 'components/uiIcons';
import { useLocale } from 'contexts/locale';

const InternationalizationSwitch = () => {
  const { locale, setLocale } = useLocale();
  const nextLocale = locale === 'pl' ? 'en' : 'pl';

  return (
    <Button onClick={() => setLocale(nextLocale)} variant="outlined">
      <LanguageIcon sx={{ mr: 1 }} /> {locale.toUpperCase()}
    </Button>
  );
};

export default InternationalizationSwitch;
